// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"356d1185","256":"ed2e823a","316":"88916e03","490":"c54ccae5","693":"6669f41c"}[chunkId] + ".chunk.css";
};